import React from 'react';
import cx from 'classnames';
import LoginLogout from './LoginLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div id="footer-wrapper" className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav" aria-label="Footer social links">
          <a id="unqiue-id-11" className="footer-link" href="https://www.facebook.com/bozemangov" target="_blank" rel="noopener noreferrer" aria-label="City of Bozeman on Facebook">
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <a id="unqiue-id-12" className="footer-link" href="https://twitter.com/CityofBozeman" target="_blank" rel="noopener noreferrer" aria-label="City of Bozeman on X (Twitter)">
            <FontAwesomeIcon icon={faTwitter}/>
          </a>
          <a id="unqiue-id-13" className="footer-link" href="https://www.instagram.com/cityofbzn" target="_blank" rel="noopener noreferrer" aria-label="City of Bozeman on Instagram">
            <FontAwesomeIcon icon={faInstagram}/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
